module.exports = __webpack_public_path__ + "static/media/blog3.a4ee46b8.jpg";